import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const AdditionalDocsNeeded = ({
  onShowLiveChat,
  uploadDocuments,
  redirectToApps,
  isDesktop
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Additional Documents Needed
      </div>
      <div className={styles.bold}>
        {'Thank you for sending in your documents. To complete your verification we require some additional documents.'}
      </div>
      <div>
        <span>{'An email has been sent to your registered email address, outlining the information we require.'}</span>
        <br />
        <br />
        <span>{'If you have submitted the documents already via email, please do not resubmit your documents and await feedback from the Matchbook Compliance team.'}</span>
        <br />
        <br />
        <i>{'Please note that if submitting Drivers Licences we require both the front AND back of your licence or for Passports all 4 corners of the document must be visible.'}</i>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={onShowLiveChat}
      >Live Chat</Button>
      {isDesktop ? (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={uploadDocuments}
          className={styles.primaryButton}
        >Upload Documents</Button>
      ) : (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={redirectToApps}
          className={styles.primaryButton}
        >Get the App</Button>
      )}
    </div>
  </Fragment>
);

AdditionalDocsNeeded.propTypes = {
  onShowLiveChat: PropTypes.func.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  redirectToApps: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
};

export default AdditionalDocsNeeded;

